__turbopack_context__.v({
  "closeButton": "wxDy6G_closeButton",
  "content": "wxDy6G_content",
  "fieldGroup": "wxDy6G_fieldGroup",
  "fieldLabel": "wxDy6G_fieldLabel",
  "footer": "wxDy6G_footer",
  "footerActions": "wxDy6G_footerActions",
  "footerNote": "wxDy6G_footerNote",
  "form": "wxDy6G_form",
  "header": "wxDy6G_header",
  "headerText": "wxDy6G_headerText",
  "helperText": "wxDy6G_helperText",
  "required": "wxDy6G_required",
  "root": "wxDy6G_root",
  "subtitle": "wxDy6G_subtitle",
  "title": "wxDy6G_title",
});
